var _defs, _rect, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgG11({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80.944,
    height: 80.947,
    viewBox: "0 0 80.944 80.947",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.944,
    height: 80.947,
    transform: "translate(0 0)",
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80.944,
    height: 80.947,
    transform: "translate(0 0)",
    fill: "#fc9e24"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8,9.745v2.864h.024l1.925-2h.025V23.1h2.744V6.783H8.327Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.058,9.745v2.864h.025l1.925-2h.024V23.1h2.745V6.783h-2.19Z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.925,61.625H26.1a.3.3,0,0,0,.3-.3.294.294,0,0,0-.078-.2l-.017-.018-6.057-7.838-.059-.064a.3.3,0,0,0-.221-.1.307.307,0,0,0-.2.077l-.036.042-.057.064-5.91,7.755-.091.111a.3.3,0,0,0,.248.467",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.065,62.73h-12.2a.3.3,0,0,0-.3.3v9.547a.3.3,0,0,0,.3.3h3.927V66.869a.3.3,0,0,1,.3-.3h3.645a.3.3,0,0,1,.3.3v6.007h4.031a.3.3,0,0,0,.3-.3V63.029a.3.3,0,0,0-.3-.3",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.136,64.139a.292.292,0,0,1-.3.288H63.233a.291.291,0,0,1-.3-.288V61.945a.291.291,0,0,1,.3-.287H66.84a.292.292,0,0,1,.3.287Zm0,4.052a.292.292,0,0,1-.3.289H63.233a.291.291,0,0,1-.3-.289V66a.29.29,0,0,1,.3-.288H66.84a.291.291,0,0,1,.3.288Zm-5.514-4.052a.292.292,0,0,1-.3.288H57.72a.293.293,0,0,1-.3-.288V61.945a.292.292,0,0,1,.3-.287h3.607a.291.291,0,0,1,.3.287Zm0,4.052a.292.292,0,0,1-.3.289H57.72a.293.293,0,0,1-.3-.289V66a.292.292,0,0,1,.3-.288h3.607a.291.291,0,0,1,.3.288Zm6.607-7.96H56.154a.29.29,0,0,0-.295.287V72.711a.291.291,0,0,0,.295.287H68.229a.292.292,0,0,0,.3-.287V60.518a.29.29,0,0,0-.3-.287",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.437,40.6a.156.156,0,0,1-.156.154h-2.7a.154.154,0,0,1-.155-.154V37.578a.154.154,0,0,1,.155-.155h2.7a.155.155,0,0,1,.156.155Zm0,6.923a.156.156,0,0,1-.156.155h-2.7a.154.154,0,0,1-.155-.155V44.5a.153.153,0,0,1,.155-.154h2.7a.155.155,0,0,1,.156.154Zm0,6.925a.156.156,0,0,1-.156.155h-2.7a.154.154,0,0,1-.155-.155V51.427a.154.154,0,0,1,.155-.155h2.7a.155.155,0,0,1,.156.155Zm0,6.923a.154.154,0,0,1-.156.155h-2.7a.153.153,0,0,1-.155-.155V58.352a.153.153,0,0,1,.155-.155h2.7a.155.155,0,0,1,.156.155Zm0,6.925a.156.156,0,0,1-.156.156h-2.7a.155.155,0,0,1-.155-.156V65.276a.154.154,0,0,1,.155-.154h2.7a.155.155,0,0,1,.156.154ZM33.131,40.6a.156.156,0,0,1-.156.154h-2.7a.155.155,0,0,1-.155-.154V37.578a.154.154,0,0,1,.155-.155h2.7a.155.155,0,0,1,.156.155Zm0,6.923a.156.156,0,0,1-.156.155h-2.7a.155.155,0,0,1-.155-.155V44.5a.154.154,0,0,1,.155-.154h2.7a.155.155,0,0,1,.156.154Zm0,6.925a.156.156,0,0,1-.156.155h-2.7a.155.155,0,0,1-.155-.155V51.427a.154.154,0,0,1,.155-.155h2.7a.155.155,0,0,1,.156.155Zm0,6.923a.154.154,0,0,1-.156.155h-2.7a.153.153,0,0,1-.155-.155V58.352a.154.154,0,0,1,.155-.155h2.7a.155.155,0,0,1,.156.155Zm0,6.925a.156.156,0,0,1-.156.156h-2.7a.155.155,0,0,1-.155-.156V65.276a.154.154,0,0,1,.155-.154h2.7a.155.155,0,0,1,.156.154ZM40.16,31.929H28.343a.29.29,0,0,0-.289.29V72.6a.29.29,0,0,0,.289.289H40.16a.292.292,0,0,0,.291-.289V32.219a.292.292,0,0,0-.291-.29",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.244,0H12.4a.243.243,0,0,1,.243.243V2.675a.242.242,0,0,1-.242.242H.243A.243.243,0,0,1,0,2.674V.244A.244.244,0,0,1,.244,0Z",
    transform: "translate(55.872 56.331)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.09,51.894a.289.289,0,0,1-.289.289H49.28a.289.289,0,0,1-.291-.289v-2.2a.29.29,0,0,1,.291-.29H52.8a.29.29,0,0,1,.289.29Zm0,4.075a.289.289,0,0,1-.289.287H49.28a.289.289,0,0,1-.291-.287V53.764a.29.29,0,0,1,.291-.289H52.8a.29.29,0,0,1,.289.289Zm0,4.074a.29.29,0,0,1-.289.288H49.28a.29.29,0,0,1-.291-.288V57.837a.29.29,0,0,1,.291-.289H52.8a.29.29,0,0,1,.289.289Zm0,4.073a.29.29,0,0,1-.289.289H49.28a.29.29,0,0,1-.291-.289v-2.2a.289.289,0,0,1,.291-.289H52.8a.289.289,0,0,1,.289.289Zm0,4.073a.29.29,0,0,1-.289.289H49.28a.29.29,0,0,1-.291-.289V65.984a.289.289,0,0,1,.291-.287H52.8a.289.289,0,0,1,.289.287ZM47.716,51.116v4.856a.289.289,0,0,1-.289.289H43.906a.289.289,0,0,1-.291-.289v-.611a.325.325,0,0,1,.022-.108.3.3,0,0,1,.018-.033.208.208,0,0,1,.025-.038l.033-.048c.45-.644,2.482-3.146,3.335-4.193l.086-.1a.337.337,0,0,1,.259-.123.333.333,0,0,1,.323.271Zm-.01,8.927a.289.289,0,0,1-.289.288H43.9a.289.289,0,0,1-.289-.288V57.837a.289.289,0,0,1,.289-.289h3.522a.289.289,0,0,1,.289.289Zm0,4.073a.289.289,0,0,1-.289.289H43.9a.289.289,0,0,1-.289-.289v-2.2a.288.288,0,0,1,.289-.289h3.522a.288.288,0,0,1,.289.289Zm0,4.073a.289.289,0,0,1-.289.289H43.9a.289.289,0,0,1-.289-.289V65.984A.287.287,0,0,1,43.9,65.7h3.522a.287.287,0,0,1,.289.287Zm1.837-20.633.083-.1c.8-1.02,2.134-2.669,2.787-3.469l.086-.1a.33.33,0,0,1,.582.147v3.727a.333.333,0,0,1-.321.332l-.015,0-.015,0h-2.9l-.014,0-.015,0a.333.333,0,0,1-.256-.531m4.89-8a.3.3,0,0,0-.466-.17l-.022.015-.1.126L42.232,54.258l-.054.072a.335.335,0,0,0-.1.23v18.1a.289.289,0,0,0,.29.288H54.172a.288.288,0,0,0,.289-.288V39.676a.287.287,0,0,0-.028-.121",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.109,11.963v-.888h1.034v.907c0,.371.166.586.547.586.35,0,.507-.234.507-.586v-.253a1.2,1.2,0,0,0-.5-.937l-.653-.653a2.231,2.231,0,0,1-.927-1.766V8.149A1.38,1.38,0,0,1,23.68,6.7c1.112,0,1.551.546,1.551,1.5v.536H24.216V8.159c0-.381-.176-.566-.526-.566a.487.487,0,0,0-.527.546v.136c0,.371.2.586.527.9l.711.7a2.22,2.22,0,0,1,.9,1.717v.322a1.432,1.432,0,0,1-1.619,1.551,1.377,1.377,0,0,1-1.571-1.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.017,6.773v5c0,1.025-.439,1.688-1.57,1.688a1.493,1.493,0,0,1-1.659-1.688v-5H26.9v5.112c0,.39.156.653.547.653s.546-.263.546-.653V6.773Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.584,11.963v-.888h1.034v.907c0,.371.166.586.547.586.35,0,.507-.234.507-.586v-.253a1.2,1.2,0,0,0-.5-.937l-.653-.653a2.231,2.231,0,0,1-.927-1.766V8.149A1.38,1.38,0,0,1,31.155,6.7c1.112,0,1.551.546,1.551,1.5v.536H31.691V8.159c0-.381-.176-.566-.526-.566a.487.487,0,0,0-.527.546v.136c0,.371.2.586.527.9l.711.7a2.22,2.22,0,0,1,.9,1.717v.322a1.432,1.432,0,0,1-1.619,1.551,1.377,1.377,0,0,1-1.571-1.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.038,6.773h2.956V7.68h-.917v5.707H33.955V7.68h-.917Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.185,11.289h.888l-.439-2.653h-.01Zm-1.4,2.1,1.249-6.614h1.268l1.259,6.614H38.424l-.2-1.21h-1.18l-.195,1.21Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.112,
    height: 6.614,
    transform: "translate(40.015 6.773)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7,9.231v4.156h-.937V6.773h1.093l1.2,3.794V6.773h.927v6.614h-.976Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.738,11.289h.888l-.439-2.653h-.01Zm-1.4,2.1,1.249-6.614H47.86l1.259,6.614H47.977l-.205-1.21h-1.18l-.195,1.21Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.583,10.412V12.48h.487a.48.48,0,0,0,.548-.537v-.995c0-.351-.167-.536-.556-.536Zm0-.849h.39a.469.469,0,0,0,.527-.537V8.217a.468.468,0,0,0-.536-.537h-.381Zm-1.112-2.79H51.08c1.112,0,1.483.517,1.483,1.454V8.9A.963.963,0,0,1,51.9,9.953a1,1,0,0,1,.83,1.1v.878c0,.937-.42,1.454-1.532,1.454H49.471Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.188,6.773H54.3V12.48h1.327v.907H53.188Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.038,6.773h2.654V7.68H57.15V9.573h1.1v.9h-1.1v2.01h1.542v.907H56.038Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.565,11.68V8.48A1.56,1.56,0,0,1,62.224,6.7c1.229,0,1.57.683,1.57,1.658v.781H62.78V8.266c0-.41-.137-.644-.537-.644s-.566.283-.566.683v3.551c0,.4.166.682.566.682s.537-.253.537-.643v-1.22h1.014v1.142c0,.946-.39,1.648-1.57,1.648a1.564,1.564,0,0,1-1.659-1.785",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.112,
    height: 6.614,
    transform: "translate(64.312 6.773)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.844,6.773H68.8V7.68h-.917v5.707H66.761V7.68h-.917Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.112,
    height: 6.614,
    transform: "translate(69.24 6.773)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.928,6.773h2.654V7.68H72.04V9.573h1.1v.9h-1.1v2.01h1.542v.907H70.928Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.885,11.963v-.888h1.034v.907c0,.371.166.586.547.586.35,0,.507-.234.507-.586v-.253a1.2,1.2,0,0,0-.5-.937l-.653-.653a2.231,2.231,0,0,1-.927-1.766V8.149A1.38,1.38,0,0,1,75.456,6.7c1.112,0,1.551.546,1.551,1.5v.536H75.992V8.159c0-.381-.176-.566-.526-.566a.487.487,0,0,0-.527.546v.136c0,.371.2.586.527.9l.712.7a2.222,2.222,0,0,1,.9,1.717v.322a1.432,1.432,0,0,1-1.619,1.551,1.377,1.377,0,0,1-1.571-1.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.523,21.008h.888l-.439-2.654h-.01Zm-1.4,2.1,1.249-6.614h1.268L25.9,23.1H24.762l-.2-1.21h-1.18l-.2,1.21Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4,18.949V23.1H26.46V16.491h1.093l1.2,3.794V16.491h.927V23.1H28.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.994,22.2c.458,0,.634-.273.634-.673V18.061a.579.579,0,0,0-.634-.663h-.469v4.8Zm1.746-3.931v3.063c0,1.015-.42,1.776-1.61,1.776H30.413V16.49H32.13c1.19,0,1.61.752,1.61,1.776",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.594,21.4V18.2a1.56,1.56,0,0,1,1.659-1.785c1.229,0,1.57.683,1.57,1.659v.78H37.809v-.868c0-.41-.137-.644-.537-.644s-.566.283-.566.683v3.551c0,.4.166.682.566.682s.537-.253.537-.643v-1.22h1.014v1.142c0,.946-.39,1.648-1.57,1.648A1.564,1.564,0,0,1,35.594,21.4",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.781,21.573V18.022c0-.4-.176-.683-.576-.683s-.566.283-.566.683v3.551c0,.4.176.682.566.682s.576-.282.576-.682M39.527,21.4V18.2a1.686,1.686,0,1,1,3.366,0v3.2a1.686,1.686,0,1,1-3.366,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.688,18.812h-.029L45.908,23.1h-.517l-.829-4.292h-.02V23.1h-.917V16.49h1.3l.721,3.727h.01L46.3,16.49H47.7V23.1H46.688Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5,18.812H51.47L50.719,23.1H50.2l-.829-4.292h-.02V23.1h-.917V16.49h1.3l.721,3.727h.01l.644-3.727h1.405V23.1H51.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.476,16.491v5c0,1.025-.439,1.688-1.57,1.688A1.493,1.493,0,0,1,53.247,21.5v-5h1.112V21.6c0,.39.156.653.547.653s.546-.263.546-.653V16.491Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.145,18.949V23.1h-.937V16.491H58.3l1.2,3.794V16.491h.927V23.1h-.976Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.112,
    height: 6.614,
    transform: "translate(61.16 16.491)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.878,16.491h2.956V17.4h-.917V23.1H63.795V17.4h-.917Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.112,
    height: 6.614,
    transform: "translate(66.449 16.491)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3,16.491h2.654V17.4H69.415v1.893h1.1v.9h-1.1V22.2h1.542V23.1H68.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.543,21.68v-.888h1.034V21.7c0,.371.166.586.547.586.35,0,.507-.234.507-.586v-.253a1.2,1.2,0,0,0-.5-.937l-.653-.653a2.231,2.231,0,0,1-.927-1.766v-.224a1.38,1.38,0,0,1,1.561-1.454c1.112,0,1.551.546,1.551,1.5v.536H73.65v-.575c0-.381-.176-.566-.526-.566a.487.487,0,0,0-.527.546v.136c0,.371.2.586.527.9l.711.7a2.22,2.22,0,0,1,.9,1.717v.322a1.432,1.432,0,0,1-1.619,1.551,1.377,1.377,0,0,1-1.571-1.5",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG11);
export default __webpack_public_path__ + "static/media/G11.dc8d396abb2c0193cdaa94b5ceae4e4c.svg";
export { ForwardRef as ReactComponent };